import React from "react";

import { FactBox } from "/react4xp/shared/FactBox/FactBox";
import type { FactBoxProps } from "../../../react4xp/shared/FactBox/FactBox.d";

export default function(props: Readonly<FactBoxProps>) {
  return <FactBox {...props} />;
}
